module.exports = __webpack_public_path__ + "static/img/bbc.517ca8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/brands-that-trust-us/bbc.png
// module id = S8By
// module chunks = 1